export const TRANSLATIONS_JP = {
  search: "探す",
  search_filter: "検索",
  search_page: "宿泊・体験プラン予約",
  all_breadcrumb: "宿泊・体験プラン",
  booking: "予約",
  not_found: "現在、商品を登録中です",
  all_categories: "すべてのカテゴリ",
  all_categories_shop: "キーワード",
  accommodation: "宿泊施設",
  activity: "観光・体験",
  restaurant: "グルメ",
  produce: "ショッピング",
  search_keyword: "キーワード",
  view_details: "詳細を見る",
  basic_info: "基本情報",
  map: "地図",
  home: "ホーム",
  list: "リスト",
  details: "詳細",
  name: "名前",
  address: "住所",
  phone: "電話番号",
  date: "日付",
  fax: "ファックス",
  email: "メールアドレス",
  website: "ウェブサイト",
  from: "",
  price: "価格",
  rate: "料金",
  price_range: "価格帯",
  keyword: "キーワード",
  available_products: "空室状況",
  available_products_activity: "予約状況",
  available_products_goods: "在庫状況",
  book_now: "予約",
  book_now_activ: "予約",
  book_now_goods: "購入",
  check_price: "空室状況を確認",
  check_price_activ: "予約状況を確認",
  check_price_goods: "在庫状況を確認",
  cart_empty: "カートは空です",
  first_name: "姓",
  last_name: "名",
  re_email: "メールアドレス再度入力",
  mobile: "携帯電話",
  city: "都道府県",
  state: "市区町村",
  country: "国",
  zip: "郵便番号",
  type_keywords: "キーワード",
  product: "製品",
  options: "オプション/コスト",
  totals: "合計",
  special_requests: "備考",
  quick_booking: "即時予約",
  request_book: "現地決済",
  customer_detail: "顧客の詳細",
  load_more: "もっと見る",
  request_to_book: "予約のリクエスト",
  start_time: "開始時間: {{ time }}",
  continue_payment: "予約・決済に進む",
  close: "閉じる",
  quantity: "数量",
  see_more: "続きを読む",
  see_less: "閉じる",
  modal_header: "予約リクエストを行う",
  modal_desc:
    "この予約はオペレーターに確認する必要があります。<br><br>24時間以内に、予約が承認されたかどうか、オンラインで安全に支払うことができるかどうかを確認するメールが届きます。",
  confirm: "Confirm",
  submit: "参加する",
  items: "アイテム",
  go_back: "戻る",
  booking_req_detail_wait: "予約リクエストの詳細-確認待ち",
  booking_req_instructions:
    "24時間以内に、予約リクエストがオペレーターによって受け入れられたかどうかを確認するメールが届きます。 予約リクエストが受理されるまで、支払いは行われません。",
  request_date: "リクエスト日（UTC）",
  booking_reference: "予約番号",
  booked_by: "によって予約された",
  supplier_information: "サプライヤー情報",
  total_gst: "合計（GSTを含む）",
  amount_paid: "支払額（GSTを含む）",
  amount_owing: "未払い額（GSTを含む）",
  adult: "大人",
  check_in: "チェックイン",
  check_out: "チェックアウト",
  not_found_page: "見つかりません",
  booking_date: "予約日",
  back_to_booking: "予約ページに戻る",
  sort_by: "並べ替え条件",
  name_ascending: "名前昇順",
  name_descending: "名前降順",
  rate_ascending: "価格の安い順",
  rate_descending: "価格の高い順",
  not_available: "満室",
  not_available_activ: "満席",
  not_available_goods: "在庫切れ",
  price_tax: "価格（税込)",
  shopping: "ショッピング",
  date_placeholder: "年-月-日",
  item_added: "カートに追加しました",
  warning_dist: "先にカートに入っている商品の支払を完了させてください。",
  clear_date: "日付を削除",
  adults: "大人",
  seniors: "シニア",
  children: "子供",
  duration: "所要時間",
  adults_count: "大人: ",
  seniors_count: "高齢者: ",
  children_count: "子供: ",
  check_in_date: "チェックイン {{ date }}",
  check_out_date: "チェックアウト {{ date }}",
  extra_options:
    "追加オプションを希望される場合は、最終の決済画面でご選択ください",
  minutes: "分",
  hours: "時間",
  shuzenji: "修善寺・中伊豆お散歩マップ",
  trip_history: "たびの記録",
  instructions: "使い方 / よくある質問",
  change_area: "ほかのエリアを見る",
  terms: "ご利用規約",
  app_provider: "運営会社",
  login_details: "ログイン設定",
  book_now_oto: "予約・に進む",
  add_wishlist: "予約リストに追加",
  remove_wishlist: "予約リストから削除",
  wishlists: "予約リスト",
  wishlist_empty: "予約リストは空です",
  check_availability: "予約リストを詳しく見る",
  add_to_reservation: "予約リストに追加",
  language: "言語",
  experience_reservation: "体験予約",
  category: "カテゴリー",
  reset_filter: "フィルターをリセット",
  about_okayama: "岡山について",
  inside_scoop: "内部情報",
  specialties: "特産品",
  travel_genre: "旅行ジャンル",
  lodging: "宿泊と予約",
  information: "情報",
  okatabi: "おか旅",
  reservation: "予約",
  history: "歴史",
  nature: "自然",
  townscape: "町並み",
  cherry: "桜",
  autumn: "紅葉",
  art: "芸術",
  experience: "体験",
  gourmet: "グルメ",
  onsen: "温泉",
  souvenirs: "お土産",
  tourist_info: "観光案内所",
  model_course: "モデルコース",
  event: "イベント",
  access: "アクセス",
  access_okayama: "岡山県内のアクセス",
  faq: "よくある質問",
  national_govt: "国家政府公認ガイド通訳",
  okayama_prefect: "岡山県外国人観光客受入れ協議会",
  safety_info: "旅行の安全情報とリンク",
  time_lapse: "タイムラプス撮影",
  brochure: "観光パンフレット",
  privacy_policy: "プライバシーポリシー",
  product_items: "ありました",
  product_items_jp: "件",
  keyword_plc: "キーワードを入力",
  kagamino: "カガミノ",
  other_providers: "その他のプロバイダー",
  campaign: "キャンペーン",
};
